export default {
  en: {
    title: 'Review',
    undo: 'Undo last answer',
    cardLabel: 'Card',
    preparingCards: 'Preparing cards',
    doneTitle: 'Review finished',
    allDoneTitle: 'Everything reviewed!',
    nothingBody: 'Words for review will appear on schedule. You can learn new ones in the meantime.',
    unsavedWarning: 'Some answers were not saved ({{count}}) — a network hiccup, these words will come back.',
    backToDictionaries: 'To dictionaries',
  },
  ru: {
    title: 'Повторение',
    undo: 'Отменить последнюю оценку',
    cardLabel: 'Карточка',
    preparingCards: 'Готовлю карточки',
    doneTitle: 'Повторение закончено',
    allDoneTitle: 'Всё повторено!',
    nothingBody: 'Слова для повторения появятся по расписанию. Можешь пока поучить новые.',
    unsavedWarning: 'Часть ответов не сохранилась ({{count}}) — сеть подвела, эти слова придут снова.',
    backToDictionaries: 'В словари',
  },
};
